'use strict';

angular.module('controllers')
	.directive('close', function() {
		return {
			restrict: 'EA',
			link: function(scope, element, attrs){

				var el = angular.element(element[0].querySelector( '#close-card'));
				el.bind('click', function (event) {

					var wrap = angular.element(element[0].querySelector( '.wrap-card'));
                    wrap.addClass('hide');
					wrap.after('<md-button id="open-card" aria-label="'+element[0].title+'"> <div>'+element[0].title+' </div></md-button>');

                    var cute = angular.element(element[0].querySelector( '.cute'));
                    cute.addClass('hide');

                    element.css('padding', '5px');
                    element.css('min-width', '200px');
                    //element.css('max-width', '220px');

					element.css('resize', 'none');
					//console.log(element[0].id);
					//if(element[0].id == 'card') {
						element.addClass('background-none');
					//}

					angular.element(element[0].querySelector( '#open-card')).bind('click', function (ev) {
						wrap.removeClass('hide');
						angular.element(element[0].querySelector( '#open-card')).remove();

                        cute.removeClass('hide');

                        element.css('padding', '5px 5px 35px 7px');
                        if(attrs.id == 'search' || attrs.id == 'action' || attrs.id == 'report-checkout' ){
                            element.css('padding', '12px 12px 35px 12px');
                        }
						if(attrs.id == 'card' || attrs.id == 'action' || attrs.id == 'report-checkout'){
                            //element.css('max-width', '100%');
                            element.css('min-width', '550px');
						}
                        if(attrs.id == 'search' || attrs.id == 'export' ){
                            //element.css('max-width', '50%');
                            element.css('min-width', '550px');
                        }
                        if(attrs.id == 'call' || attrs.id == 'card-order' || attrs.id == 'send-order' || attrs.id == 'history-order') {
                            //element.css('max-width', '50%');
                            element.css('min-width', '97%');
                        }
                        if(attrs.id == 'dispatch-order'){
                            //element.css('max-width', '50%');
                            element.css('min-width', '320px');
                        }
                        if(attrs.id == 'dispatch-slot'){
                            //element.css('max-width', '50%');
                            element.css('min-width', '50%');
                        }
                        if(attrs.id == 'card-locations'){
                            element.css('min-width', '230px');
                        }
                        if(attrs.id == 'card-history'){
                            element.css('min-width', '230px');
                        }
                        element.css('resize', 'horizontal');
						/*
						element.removeClass('background-none');*/
					});

				});


			}
		}

	});
